export default "__VITE_ASSET__CIafcI7z__"